// extracted by mini-css-extract-plugin
module.exports = {"navMenu":"navMenu_navMenu__WVeCb"};